
const initialState = {
    data: [
        {code: null, title: 'neuvedeno'},
        {code: '2', title: 'orná půda'},
        {code: '3', title: 'chmelnice'},
        {code: '4', title: 'vinice'},
        {code: '5', title: 'zahrada'},
        {code: '6', title: 'ovocný sad'},
        {code: '7', title: 'trvalý travní porost'},
        {code: '10', title: 'lesní pozemek'},
        {code: '11', title: 'vodní plocha'},
        {code: '13', title: 'zastavěná plocha a nádvoří'},
        {code: '14', title: 'ostatní plocha'}
    ]
};

export function getDrupozTitle(state, drupozKod) {
    return state.data.reduce((previous, current) => {
        return (current.code === drupozKod)
            ? current.title
            : previous;
    }, drupozKod);
}

export default function drupoz(state = initialState, action) {
    switch (action.type) {
        default:
            return state;
    }
}